<div class="container">
  <img class="file-icon" src="assets/file-icon.svg">
  <div (click)="openFileInNewTab()" [ngClass]="{ link: hasFileUrl()}" class="file-name">{{getFileNameText()}}</div>
  <div class="file-size">{{formatBytesToText(amountOfBytes)}}</div>
</div>